import React, {useEffect, useState} from "react";
import {Box, Container, Typography} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";
import {TrackingContentState} from "./TrackingContentState";
import {TrackingSearchForm} from "./TrackingSearchForm";
import {TrackingTypeSelector} from "./TrackingTypeSelector";
import {buildGeneratedMockResult, buildNoTrackingPreviewResult, dummyData, mapApiDataToResult} from "./trackingData";
import {normalizeTrackingNumber} from "./trackingConfig";
import axios from "axios";
import {PARTNER_URI} from "../../Utils/apiUrl";

export const TrackingNew = ({
                                truckVariant = "solid",
                                historyLayout = "timeline",
                                transparentReadyState = false,
                                useAppTabs = false
                            }) => {
    const theme = useTheme();
    // const pageBackground = `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${theme.palette.background.default} 220px)`;
    const pageBackground = useAppTabs
        ? theme.palette.background.default
        : `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${theme.palette.background.default} 220px)`;
    const [trackingType, setTrackingType] = useState("ltl");
    const [trackingNumber, setTrackingNumber] = useState("");
    const [result, setResult] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [resultVersion, setResultVersion] = useState(0);

    useEffect(() => {
        const previousHtmlOverflowX = document.documentElement.style.overflowX;
        const previousBodyOverflowX = document.body.style.overflowX;
        const previousHtmlBackground = document.documentElement.style.background;
        const previousBodyBackground = document.body.style.background;

        document.documentElement.style.overflowX = "clip";
        document.body.style.overflowX = "clip";
        document.documentElement.style.background = pageBackground;
        document.body.style.background = pageBackground;

        return () => {
            document.documentElement.style.overflowX = previousHtmlOverflowX;
            document.body.style.overflowX = previousBodyOverflowX;
            document.documentElement.style.background = previousHtmlBackground;
            document.body.style.background = previousBodyBackground;
        };
    }, [pageBackground]);

    const handleTrackingTypeChange = (type) => {
        setTrackingType(type);
        setTrackingNumber("");
        setResult(null);
        setHasSearched(false);
    };


    const handleSubmit = async () => {
        const normalizedValue = normalizeTrackingNumber(trackingNumber);
        if (!normalizedValue) return;

        setHasSearched(true);
        setIsLoading(true);
        setResultVersion((version) => version + 1);

        try {
            const requestURL = `${PARTNER_URI}/generalTracking/retrieveTracking`;

            const shipmentTypeId = trackingType === "package" ? 5 : 1;
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    shipmentTypeId,
                    trackingNumber: normalizedValue,
                },
            });
            console.log('[retrieveTracking] api result', result);
            const nextResult = mapApiDataToResult(result.data);
            setResult(nextResult);

        } catch (e) {
            // setError(err.response?.data?.message || "Unable to retrieve tracking information. Please try again.");
            setResult(null);
        } finally {
            setIsLoading(false);
        }

        // Mock delay keeps the loading state visible for the UI prototype.
        // await new Promise((resolve) => window.setTimeout(resolve, 1400));
        // const nextResult = mapApiDataToResult(dummyData);
        // // const nextResult = buildGeneratedMockResult(normalizedValue);
        // setResult(nextResult);
        // setIsLoading(false);
    };

    console.log('[TrackingNew] result', result);

    return (
        <Box sx={{minHeight: "100vh", background: pageBackground, py: {xs: 1.5, md: 3}, overflowX: "hidden"}}>
            <Container maxWidth="lg" sx={{px: {xs: 2, sm: 3}}}>
                <Box sx={{maxWidth: 1080, mx: "auto"}}>
                    <Box sx={{mb: {xs: 1.25, sm: 1.5}}}>
                        <Typography variant="h2" sx={{
                            fontSize: {xs: 22, sm: 24},
                            lineHeight: 1.25,
                            letterSpacing: {xs: "-0.6px", sm: "-1.2px"}
                        }}>Track Your Shipment</Typography>
                        <Typography variant="body2" sx={{mt: 0.5, color: "neutral.500"}}>
                            {trackingType === "package" ? "Enter your package tracking number to see live status." : "Enter a BOL, PRO, or pickup number to see live status."}
                        </Typography>
                    </Box>
                    {/*<Box sx={{display: "flex", justifyContent: "flex-start", mb: {xs: 1.5, sm: 2}}}>*/}
                    {/*    <TrackingTypeSelector value={trackingType} onChange={handleTrackingTypeChange}/>*/}
                    {/*</Box>*/}
                    <Box sx={{
                        display: useAppTabs ? "block" : "flex",
                        justifyContent: "flex-start",
                        mb: {xs: 1.5, sm: 2}
                    }}>
                        <TrackingTypeSelector
                            value={trackingType}
                            onChange={handleTrackingTypeChange}
                            variant={useAppTabs ? "line" : "pill"}
                        />
                    </Box>
                    <TrackingSearchForm
                        trackingType={trackingType}
                        trackingNumber={trackingNumber}
                        isLoading={isLoading}
                        onTrackingNumberChange={setTrackingNumber}
                        onSubmit={handleSubmit}
                    />
                    <Box sx={{mt: {xs: 1.5, sm: 2}}}>
                        <TrackingContentState
                            isLoading={isLoading}
                            result={result}
                            hasSearched={hasSearched}
                            resultVersion={resultVersion}
                            trackingType={trackingType}
                            truckVariant={truckVariant}
                            historyLayout={historyLayout}
                            transparentReadyState={transparentReadyState}
                        />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export const TrackingNew2 = () => <TrackingNew truckVariant="line" historyLayout="table" transparentReadyState useAppTabs/>;
